module.exports = __webpack_public_path__ + "img/boletoIcon.5ca7877b.svg";